import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import DesiredOutcomes from './DesiredOutcomes';

const DesiredOutcomesPicker = ({ tabResource }) => {
  return pick(tabResource, {
    [fr.relationships.tabData.name]: <DesiredOutcomes
      tabDataRelationship={tabResource?.relationship(fr.relationships.tabData.name)}
    />,
  }, () => null);
};

DesiredOutcomesPicker.propTypes = {
  tabResource: PropTypes.object.isRequired,
};

export default DesiredOutcomesPicker;
